import { CLOSE_SEARCH, OPEN_SEARCH } from "core-web/state/models/Header/constants";

import store from "core-web/state/store";

export const toggleSearch = (toggleState) => (dispatch) => {
    if (toggleState) {
        dispatch({
            type: OPEN_SEARCH,
        });
    } else {
        dispatch({
            type: CLOSE_SEARCH,
        });
    }
};

export default (toggleState) => store.dispatch(toggleSearch(toggleState));
